import { State } from "./State";
export class GridColumn {
    constructor(id, name, type, required) {
        this.id = id;
        this.name = new State(name);
        this.type = new State(type);
        this.required = new State(required);
    }
    toJSON() {
        return {
            id: this.id,
            name: this.name.value,
            type: this.type.value,
            required: this.required.value,
        };
    }
}
